import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import focusValuesUK from "@/.sourceflow/about_us_focus_values.json";

export const useFocusValues = ({ limit } = {}) => {
  const collection = useSourceFlowCollection(focusValuesUK);

  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useFocusValues;
